import React from 'react'
import { ResponsiveBar } from '@nivo/bar'
const colors = ['#24CE34', '#DF853C', '#F9D429'];
export const CardChartBar = ({ responsesData }) => {
    return (
        <div className='w-full  h-full '>
            <MyResponsiveBar data={responsesData}></MyResponsiveBar>
        </div>
    )
}


const MyResponsiveBar = ({ data = [
    {
        "question": "AD",
        "correct": 7,
        "correctColor": "hsl(267, 70%, 50%)",
        "incorrect": 9,
        "incorrectColor": "hsl(176, 70%, 50%)",
    },
    {
        "question": "AE",
        "correct": 12,
        "correctColor": "hsl(83, 70%, 50%)",
        "incorrect": 10,
        "incorrectColor": "hsl(325, 70%, 50%)",
    },
    {
        "question": "Az",
        "correct": 15,
        "correctColor": "hsl(83, 70%, 50%)",
        "incorrect": 10,
        "incorrectColor": "hsl(325, 70%, 50%)",
    },
    {
        "question": "Aa",
        "correct": 18,
        "correctColor": "hsl(83, 70%, 50%)",
        "incorrect": 10,
        "incorrectColor": "hsl(325, 70%, 50%)",
    },
] /* see data tab */ }) => (
    <ResponsiveBar
        data={data}
        keys={[
            'correct',
            'incorrect',
        ]}
        indexBy="question"
        margin={{ top: 20, right: 70, bottom: 30, left: 40 }}
        padding={0.3}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={colors}
        axisTop={null}
        axisRight={null}
        enableLabel={false}
        role="application"
        ariaLabel="Nivo bar chart demo"
    />
)

export default CardChartBar